import { BrandRtps } from '../../models/rtps.model';
import { assignDefined } from '../../models/util.model';

export class QueryParamHelperUtil{
  static getParameterByName(name: string, url: string) {
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results) return '';
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  static getSearchStr(): string {
    if(!location){
      return '';
    }
    return location.search || '';
  }

  static getAttributionQueryParams(): Partial<BrandRtps> {
    /*
    * Sample url search str
    * clientName=apire&prescreenId=320000000001&loyaltyNumber=1234567890123&customerNumber=71717171&channel=4&subChannel=X
    * */
    const searchStr = QueryParamHelperUtil.getSearchStr();
    const resp = assignDefined({}, {
      channel: QueryParamHelperUtil.getParameterByName('channel', searchStr),
      subchannel: QueryParamHelperUtil.getParameterByName('subChannel', searchStr) ||
        QueryParamHelperUtil.getParameterByName('subchannel', searchStr),
      prescreenId: QueryParamHelperUtil.getParameterByName('prescreenId', searchStr),
      loyaltyNumber: QueryParamHelperUtil.getParameterByName('loyaltyNumber', searchStr),
      customerNumber: QueryParamHelperUtil.getParameterByName('customerNumber', searchStr),
      customerAcceptedOffer: QueryParamHelperUtil.getParameterByName('customerAcceptedOffer', searchStr)
    });

    if (!!resp.customerAcceptedOffer && resp.customerAcceptedOffer === 'true') {
      resp.customerAcceptedOffer = true;
    } else if (!!resp.customerAcceptedOffer && resp.customerAcceptedOffer === 'false') {
      resp.customerAcceptedOffer = false;
    }

    return resp;

  }
}
